<template lang="pug">
  div.report-tab.body.body-table.garbages
    div.table-choose-panel
      div.toolbar-table
        e-select-list(
        :options="selectListOptions"
        v-model="operationType"
        )

        div.toolbar.toolbar--modal
          div.line
            div.actions-panel
              e-button-add(
              @click="addNewRowToTable"
              )
              // button(v-if="role!=='guest'" type="button" @click="addNewRowToGarbageTable").actions-panel__button.btn-add.green

      div(v-if="operationType === 'legalEntity'")
        e-table-editable(
        ref="legalEntity"
        :attributes="legalEntityAttr"
        :dataUrl="dataUrl"
        :postUrl="postUrl"
        :patchUrl="patchUrl"
        :deleteUrl="deleteUrl"
        :tableInOnlineMode="tableInOnlineMode"
        @sortByField="onSortByField"
        :enablePagination="true"
        @paginate="onPaginate"
        )

      // used for fill demo data only
      div(v-if="operationType === 'individual'")
        e-table-editable(
        ref="individual"
        :attributes="individualAttr"
        :dataUrl="individualDataUrl"
        :postUrl="individualPostUrl"
        :patchUrl="individualPatchUrl"
        :deleteUrl="individualDeleteUrl"
        :tableInOnlineMode="tableInOnlineMode"
        @sortByField="onSortByField"
        :enablePagination="true"
        @paginate="onPaginate"
        )
</template>

<script>
  import {mongoApi} from '../../../api/api-endpoints.js'
  import {sourcesWasteOffline} from '../../../api/api-offline-endpoints.js'
  import {SourcesWasteSourcesLegalEntity, SourcesWasteSourcesIndividual} from '../../../config/mongo'

  export default {
    name: 'garbages',
    props: {
      id: null,
      tabView: null
    },
    data () {
      return {
        operationType: null,
        search: '',
        searchModel: '',
        sort: null,
        paginationQuery: null
      }
    },
    computed: {
      selectListOptions () {
        return [
          {
            id: 'legalEntity',
            name: 'Юридические лица'
          },
          {
            id: 'individual',
            name: 'Физические лица'
          }
        ]
      },
      tableInOnlineMode () {
        return this.$route.params.id
      },
      enableSort () {
        return true
      },
      legalEntityAttr () {
        return {
          fio: {
            label: 'Наименование',
            placeholder: ' ',
            validationRulePattern: '(\\.*)'
          },
          a: {
            label: 'ИНН',
            placeholder: ' ',
            validationRulePattern: '(\\.*)'
          },
          b: {
            label: 'Юридический адрес',
            placeholder: ' ',
            validationRulePattern: '(\\.*)'
          },
          c: {
            label: 'Номер р/с',
            placeholder: ' ',
            validationRulePattern: '(\\.*)'
          },
          d: {
            label: 'Номер лицевого счета',
            placeholder: ' ',
            validationRulePattern: '(\\.*)'
          },
          e: {
            label: 'Способ коммерческого учета отходов',
            placeholder: ' ',
            validationRulePattern: '(\\.*)'
          }
        }
      },
      dataUrl () {
        if (this.tableInOnlineMode) {
          let routeQuery = {
            query: {
              filter: {
                sourceId: this.id
              }
            }
          }
          if (this.search) {
            routeQuery.query.q = this.search
          }
          if (this.sort) {
            routeQuery.query.sort = this.sort
          }
          if (this.paginationQuery) {
            routeQuery.query = Object.assign(routeQuery.query, this.paginationQuery)
          }

          return mongoApi.getCollectionItems(SourcesWasteSourcesLegalEntity, routeQuery)
        }
        // if new record, offline save
        return sourcesWasteOffline.garbagesTable(this.$route.name, this.operationType)
      },
      individualAttr () {
        return {
          fio: {
            label: 'ФИО',
            placeholder: ' ',
            validationRulePattern: '(\\.*)'
          },
          a: {
            label: 'ИНН',
            placeholder: ' ',
            validationRulePattern: '(\\.*)'
          },
          b: {
            label: 'Адрес',
            placeholder: ' ',
            validationRulePattern: '(\\.*)'
          },
          c: {
            label: 'Номер р/с',
            placeholder: ' ',
            validationRulePattern: '(\\.*)'
          },
          d: {
            label: 'Номер лицевого счета',
            placeholder: ' ',
            validationRulePattern: '(\\.*)'
          },
          roomType: {
            label: 'Тип помещения',
            select: {
              options: this.roomTypes
            },
            transform: (model) => model['labelForroomType'] || '',
            validationRulePattern: '(\\.*)'
          }
        }
      },
      roomTypes () {
        return [
          {id: 1, name: 'Жилое'},
          {id: 2, name: 'Нежилое'}
        ]
      },
      individualDataUrl () {
        if (this.tableInOnlineMode) {
          let routeQuery = {
            query: {
              filter: {
                sourceId: this.id
              }
            }
          }
          if (this.search) {
            routeQuery.query.q = this.search
          }
          if (this.sort) {
            routeQuery.query.sort = this.sort
          }
          if (this.paginationQuery) {
            routeQuery.query = Object.assign(routeQuery.query, this.paginationQuery)
          }

          return mongoApi.getCollectionItems(SourcesWasteSourcesIndividual, routeQuery)
        }
        return sourcesWasteOffline.garbagesTable(this.$route.name, this.operationType)
      }
    },
    methods: {
      onPaginate (paginationQuery) {
        this.paginationQuery = paginationQuery
      },
      onSortByField ({sort}) {
        this.sort = sort
      },
      afterFetchData (ctx, data) {
        for (let i = 0; i < data.data.length; i++) {

        }

        // console.log(data.data)
        return data
      },
      postUrl (context, model) {
        return mongoApi.createCollectionItem(SourcesWasteSourcesLegalEntity)
      },
      patchUrl (context, model) {
        return mongoApi.updateCollectionItem(SourcesWasteSourcesLegalEntity, model.id)
      },
      deleteUrl (context, model) {
        return mongoApi.deleteCollectionItem(SourcesWasteSourcesLegalEntity, model.id)
      },
      individualPostUrl (context, model) {
        return mongoApi.createCollectionItem(SourcesWasteSourcesIndividual)
      },
      individualPatchUrl (context, model) {
        return mongoApi.updateCollectionItem(SourcesWasteSourcesIndividual, model.id)
      },
      individualDeleteUrl (context, model) {
        return mongoApi.deleteCollectionItem(SourcesWasteSourcesIndividual, model.id)
      },
      addNewRowToTable () {
        const Model = (id) => {
          return {
            sourceId: id || '',
            roomType: ''
          }
        }
        if (this.operationType === 'legalEntity') {
          this.$refs.legalEntity.createRow(new Model(this.id))
        } else if (this.operationType === 'individual') {
          this.$refs.individual.createRow(new Model(this.id))
        }
      }
    }
  }
</script>
